import { Injectable } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import 'firebase/storage';
import { Observable } from 'rxjs';
import { environment } from '../../../../src/environments/environment';
import { AntEnvService } from './ant.env.svc';
import { shareReplay, timestamp } from 'rxjs/operators';

@Injectable()
export abstract class AbsDataService{
    abstract login(email: string, password: string);
}

@Injectable({ providedIn: 'root' })
export class DataService implements AbsDataService {
    
    // private readonly CONFIG_URL = 'assets/contando.json?t=' + new Date().getTime();
    private headers4Cors = { headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };

    apiUrl: string ;//= environment.apiUrl;
    uiUrl: string;
    user: any;
    fullScreen: boolean = false;
    public dsDateParam: any = [];
    public dsDateParam2: any = [];
    public dsCompareDateParam: any = [];
    public dsCompareDateParam2: any = [];
    public dsAreaId: any = null;
    public dsHideAnalytics: boolean = false;
    public dsHideMonthlyOverview: boolean = false;
    //private antEnv$: Observable<AntEnv>;

    constructor(
        private http: HttpClient,
        // private firebaseAuth: AngularFireAuth,
        private svcAntEnv: AntEnvService
    ) {
        // this.antEnv$ = this.http.get<AntEnv>(this.CONFIG_URL).pipe(
        //     shareReplay(1)
        //   );
        //   this.antEnv$.subscribe(res => {
        //     console.log(res)
        //     this.apiUrl = res.apiUrl;
        //   })
        this.svcAntEnv.load().subscribe(res=>{
            if(res.apiUrl != null){
                //console.log(res)
                this.apiUrl = res.apiUrl;
                this.uiUrl = res.uiUrl;
            }
        });
    }
    login(email: string, password: string) {
        throw new Error('Method not implemented.');
    }
    public getData(): any[] {
        return [ 'Game of Thrones', 'Breaking Bad', 'The Walking Dead' ];
    }
    areaAdd(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/area/create`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    updateFPImage(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/area/updatefpimage`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    uploadFPImage(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/data/fpImageUpload`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    getFPImage(argArea):Observable<any>{
        var url = `${this.apiUrl}/api/data/getFpImage`;
        return this.http.post(url, argArea, this.headers4Cors);
    }
    uploadCSV(argCSV: string,date,startHour,endHour,tzMinute):Observable<any>{
        var url = `${this.apiUrl}/api/data/import/agv/csv/json/${date}/startHour/${startHour}/endHour/${endHour}/timezoneMinute/${tzMinute}`;
        return this.http.post(url, { Param1: argCSV }, this.headers4Cors);
    }
    cacheRebuild(date):Observable<any>{
        var url = `${this.apiUrl}/api/data/stash/hourly/run/${date}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    configAdd(argId, argKey, argValue):Observable<any>{
        var _arg = {
            id: argId, key: argKey, value: argValue
        };
        var url = `${this.apiUrl}/api/config/create`;
        return this.http.post(url, _arg, this.headers4Cors);
    }
    areaDetail(areaId): Observable<any>{
        var url = `${this.apiUrl}/api/area/${areaId}/detail`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaList(parentId): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/parent/${parentId}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaListAll(): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaListForDashboard(): Observable<any>{
        //console.log(this.apiUrl);
        var url = `${this.apiUrl}/api/area/list/dashboard/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    areaListForOccupancy(): Observable<any>{
        var url = `${this.apiUrl}/api/area/list/occupancy/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    isBusinessHour():Observable<any>{
        var url = `${this.apiUrl}/api/data/isBusinessHour/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorAdd(argSensor):Observable<any>{
        var url = `${this.apiUrl}/api/sensor/create`;
        return this.http.post(url, argSensor, this.headers4Cors);
    }
    sensorData(areaId, startTimeStr, endTimeStr): Observable<any>{
        //console.log(startTimeStr," ", endTimeStr);
        var url = `${this.apiUrl}/api/data/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorData3AM(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/area/3am/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorData3AMAnalytic(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/area/3amanalytic/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataStdDev(areaId, startTimeStr, endTimeStr): Observable<any>{
        //console.log(startTimeStr," ", endTimeStr);
        var url = `${this.apiUrl}/api/data/stddev/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataStdDev3AM(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/stddev/area/3am/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataMW(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/n/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataMW3AM(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/n/3am/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataMWEX(areaId, startTimeStr, endTimeStr): Observable<any>{
        //console.log('mwex')
        //console.log(startTimeStr,' ', endTimeStr)
        var url = `${this.apiUrl}/api/data/n/weekly/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataMWEX3AM(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/n/3am/weekly/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensor(areaId, sensorId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorAlone(sensorId, startTimeStr, endTimeStr, tzMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorCC(areaId, sensorId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/cc/sensor/${sensorId}/area/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorAloneCC(sensorId, startTimeStr, endTimeStr, tzMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/cc/sensor/${sensorId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataBySensorAloneByFrequencyMinute(sensorId, startTimeStr, endTimeStr, tzMinute, frequencyMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/frequencyMinute/${frequencyMinute}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataListByFrequencyMinute(areaId, sensorListJson, startTimeStr, endTimeStr, tzMinute, frequencyMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/dataList/area/${areaId}/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/frequencyMinute/${frequencyMinute}/`;
        //console.log(sensorListJson);
        return this.http.post(url, { token: '', param1: sensorListJson }, this.headers4Cors);
    }
    sensorDataForReportDaily(startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/all/report/daily/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataImportHourly(sensorId, timestampStr, inValue, outValue): Observable<any>{
        var url = `${this.apiUrl}/api/data/import/sensorData/hourly/${sensorId}/${timestampStr}/${inValue}/${outValue}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataLastData(): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/lastData/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorDataRaw(sensorId, startTimeStr, endTimeStr, tzMinute): Observable<any>{
        var url = `${this.apiUrl}/api/data/sensor/${sensorId}/raw/${startTimeStr}/${endTimeStr}/timezoneMinute/${tzMinute}/`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorRemove(argSensor):Observable<any>{
        var url = `${this.apiUrl}/api/sensor/delete`;
        return this.http.post(url, argSensor, this.headers4Cors);
    }
    sensorUpdate(argSensor):Observable<any>{
        var url = `${this.apiUrl}/api/sensor/update`;
        return this.http.post(url, argSensor, this.headers4Cors);
    }
    // login(email: string, password: string): Promise<firebase.default.auth.UserCredential> {
    //     return this.firebaseAuth.signInWithEmailAndPassword(email, password);
    // }
    // resetPassword(email: string) {
    //     return this.firebaseAuth.sendPasswordResetEmail(email);
    // }
    templateCreate(argTemplate):Observable<any>{
        var url = `${this.apiUrl}/api/template/create`;
        return this.http.post(url, argTemplate, this.headers4Cors);
    }
    templateDelete(argTemplate):Observable<any>{
        var url = `${this.apiUrl}/api/template/delete`;
        return this.http.post(url, argTemplate, this.headers4Cors);
    }
    templateList(templateType):Observable<any>{
        var url = `${this.apiUrl}/api/template/list/type/${templateType}`;
        return this.http.post(url, {}, this.headers4Cors);
    }
    templateUpdateSubjectBody(argTemplate):Observable<any>{
        var url = `${this.apiUrl}/api/template/update/subjectBody`;
        return this.http.post(url, argTemplate, this.headers4Cors);
    }
    userAdd(arg): Observable<any>{
        var url = `${this.apiUrl}/api/user/create/`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    userConfigGet(userId, code): Observable<any>{
        return this.http.post(`${this.apiUrl}/api/user/config/get`, {userId:userId, param1: code}, this.headers4Cors);
    }
    userConfigSet(userId, code, value): Observable<any>{
        return this.http.post(`${this.apiUrl}/api/user/config/set`, {userId:userId, param1: code, param2: value}, this.headers4Cors);
    }
    userDelete(arg): Observable<any>{
        var url = `${this.apiUrl}/api/user/delete/`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    userUpdateFullNameAndRole(arg): Observable<any>{
        var url = `${this.apiUrl}/api/user/update/fullNameAndRole/`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    userList(): Observable<any>{
        var url = `${this.apiUrl}/api/user/list/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    userListByCustomPort(port:any): Observable<any>{
        var arrApiUrlSegment = this.apiUrl.split(':');
        var firstSegment = arrApiUrlSegment[0];
        var secondSegment = arrApiUrlSegment[1];
        var thirdSegment = port;
        var newApiUrl = firstSegment+":"+secondSegment+":"+thirdSegment;
        //console.log(newApiUrl);
        var url = `${newApiUrl}/api/user/list/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    alertTypeList(): Observable<any>{
        var url = `${this.apiUrl}/api/pushnotilog/alertTypeList/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    // logout() {
    //     this.firebaseAuth.signOut();
    // }
    usageAdd(argUsage):Observable<any>{
        var url = `${this.apiUrl}/api/Usage/Create`;
        
        return this.http.post(url, argUsage, this.headers4Cors);
    }
    sessionAdd(argSession):Observable<any>{
        var url = `${this.apiUrl}/api/user/session/add`;
        return this.http.post(url, argSession, this.headers4Cors);
    }
    sessionUpdate(argSession):Observable<any>{
        var url = `${this.apiUrl}/api/user/session/update`;
        return this.http.post(url, argSession, this.headers4Cors);
    }
    checkSession(argSession):Observable<any>{
        var url = `${this.apiUrl}/api/user/session/check`;
        return this.http.post(url, argSession, this.headers4Cors);
    }
    usageListByDate(startDate, endDate, name, actionCode): Observable<any>{
        var url = `${this.apiUrl}/api/usage/list/`;
        return this.http.post(url, { StartDate: startDate,EndDate: endDate, Name: name, ActionCode: actionCode }, this.headers4Cors);
    }
    usageListByDateChart(startDate, endDate, name, actionCode): Observable<any>{
        var url = `${this.apiUrl}/api/usage/chartlist/`;
        return this.http.post(url, { StartDate: startDate,EndDate: endDate, Name: name, ActionCode: actionCode }, this.headers4Cors);
    }
    lastLoginTime(): Observable<any>{
        var url = `${this.apiUrl}/api/usage/lastLoginTimelist/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getDwellTimeData(timestamp): Observable<any>{
        var url = `${this.apiUrl}/api/data/getdwelltime/${timestamp}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getDwellTimeDataLastWeek(timestamp): Observable<any>{
        var url = `${this.apiUrl}/api/data/getdwelltimeLastWeek/${timestamp}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    addDwellTime(startTime, endTime, areaId): Observable<any>{
        var url = `${this.apiUrl}/api/data/dwelltime/${areaId}/${startTime}/${endTime}/`;        
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    isShowDTD(areaId): Observable<any>{
        var url = `${this.apiUrl}/api/data/isdwelltime/${areaId}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    hourlyDwellTimeData(startTime, endTime, areaId): Observable<any>{
        var url = `${this.apiUrl}/api/data/gethourlydwelltime/${areaId}/${startTime}/${endTime}/`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    locationSetUp(areaId, sensorId,x,y): Observable<any>{
        var url = `${this.apiUrl}/api/locationsetup/create/${areaId}/${sensorId}/${x}/${y}/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    sensorLocation(areaId): Observable<any>{
        var url = `${this.apiUrl}/api/locationsetup/getlocationlist/${areaId}/`;
        //console.log(url)
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    getTopSensorData(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/topsensordata/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getTopSensorData3AM(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/topsensordata/3am/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHisTopSensorData(areaId, startTimeStr, endTimeStr, hisStartTimeStr, hisEndTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/histopsensordata/${areaId}/${startTimeStr}/${endTimeStr}/${hisStartTimeStr}/${hisEndTimeStr}`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHisTopSensorData3AM(areaId, startTimeStr, endTimeStr, hisStartTimeStr, hisEndTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/histopsensordata/3am/${areaId}/${startTimeStr}/${endTimeStr}/${hisStartTimeStr}/${hisEndTimeStr}`;
        //console.log(url);
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getAllSensorData(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/allsensordata/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getAllSensorData3AM(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/allsensordata/3am/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHourlyRangeDwellTimeList(areaId, startTimeStr, endTimeStr): Observable<any> {
        var url = `${this.apiUrl}/api/data/hourlyrangedwelltime/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getHourlyDwellTimeGH(areaId, dataDate): Observable<any> {
        var url = `${this.apiUrl}/api/data/getdwelltimegh/${areaId}/${dataDate}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    alertUpdateByAlertId(id, arg): Observable<any>{
        var url = `${this.apiUrl}/api/alert/update/${id}`;
        //console.log(arg);
        return this.http.post(url, arg, this.headers4Cors);
    }

    alertListByAlertId(alertId): Observable<any>{
        var url = `${this.apiUrl}/api/alert/alertlist/${alertId}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    alertListDetails(): Observable<any>{
        var url = `${this.apiUrl}/api/pushnotilog/alertlist/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    saveToken(tkn: any, usr: any): Observable<any>{
        //console.log(tkn, " ", usr);
        var url = `${this.apiUrl}/api/pushnotilog/savetoken/${tkn}/${usr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors); 
    }
    
    deleteToken(tkn: any, usr: any): Observable<any>{
        //console.log(tkn, " ", usr);
        var url = `${this.apiUrl}/api/pushnotilog/deletetoken/${tkn}/${usr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors); 
    }

    alertSaveNewRecord(userId, arg): Observable<any>{
        var url = `${this.apiUrl}/api/alert/save/${userId}`;
        //console.log(arg);
        return this.http.post(url, arg, this.headers4Cors);
    }

    alertDelete(id: any): Observable<any>{
        var url = `${this.apiUrl}/api/alert/alertdelete/${id}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    showStdDev(): Observable<any>{
        var url = `${this.apiUrl}/api/data/showstddev`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    forgotPassword(email: any): Observable<any>{
        var _arg = {
            email: email,
            url: this.uiUrl.toString()
          }
        var url = `${this.apiUrl}/api/user/forgotpassword`;
        return this.http.post(url, _arg, this.headers4Cors);
    }
    forgotPasswordTokenGet(arg: any): Observable<any>{
        var url = `${this.apiUrl}/api/user/forgotpasswordtoken/get`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    resetPassword(arg: any): Observable<any>{
        var url = `${this.apiUrl}/api/user/resetpassword`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    saveRemark(arg: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/saveremark`;
        return this.http.post(url, arg, this.headers4Cors);
    }
    getRemark(date: any, eDate: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/getremark/${date}/${eDate}`;
        return this.http.post(url, {token: ''}, this.headers4Cors);
    }
    updateRemark(remarkId: any, remark: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/updateremark/${remarkId}/${remark}`;
        return this.http.post(url, {"token": ""}, this.headers4Cors);
    }
    remarkList(): Observable<any>{
        var url = `${this.apiUrl}/api/data/remarklist/`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    calendarDashboardList(areaId: any, startTime: any, endTime: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/calendardashboarddatalist/${areaId}/${startTime}/${endTime}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    calendarDashboardList3AM(areaId: any, startTime: any, endTime: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/calendardashboarddatalist3AM/${areaId}/${startTime}/${endTime}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    quarterlyDataList(startTime: any, endTime: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/quarterlydatalist/${startTime}/${endTime}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    quarterlyDataList3AM(startTime: any, endTime: any): Observable<any>{
        var url = `${this.apiUrl}/api/data/quarterlydatalist/3am/${startTime}/${endTime}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    weekDayAdd(argId, argValue):Observable<any>{
        var _arg = {
            id: argId, name: '', status: argValue
        };
        var url = `${this.apiUrl}/api/data/weekdayweekendinsert`;
        return this.http.post(url, _arg, this.headers4Cors);
    }
    getFaceRecDataByGender(startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/getfacereclistbygender/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getFaceRecDataByAgeGroup(startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/getfacereclistbyagegroup/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    licenseActivate(arg):Observable<any>{
        var url = `${this.apiUrl}/api/user/activatelicense/${arg}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }

    GetLicenseExpiredDate():Observable<any>{
        var url = `${this.apiUrl}/api/user/getlicenseexpireddate`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
    getAnalyticReportData(areaId, startTimeStr, endTimeStr): Observable<any>{
        var url = `${this.apiUrl}/api/data/getanalyticreportdata/3am/${areaId}/${startTimeStr}/${endTimeStr}`;
        return this.http.post(url, { token: '' }, this.headers4Cors);
    }
}


interface AntEnv{
    apiUrl:string;
    client:string;
};